var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V9.25H19C19.4142 9.25 19.75 9.58579 19.75 10V11C19.75 15.0272 16.6783 18.337 12.75 18.7142V21.25H15C15.4142 21.25 15.75 21.5858 15.75 22C15.75 22.4142 15.4142 22.75 15 22.75H9C8.58579 22.75 8.25 22.4142 8.25 22C8.25 21.5858 8.58579 21.25 9 21.25H11.25V18.7142C7.3217 18.337 4.25 15.0272 4.25 11V10C4.25 9.58579 4.58579 9.25 5 9.25H7V7ZM18.25 11V10.75H17V11C17 13.7614 14.7614 16 12 16C9.23858 16 7 13.7614 7 11V10.75H5.75V11C5.75 14.4518 8.54822 17.25 12 17.25C15.4518 17.25 18.25 14.4518 18.25 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneAlt);
export default __webpack_public_path__ + "static/media/microphone-alt.a00fa8feaa131041777d37853e7c3741.svg";
export { ForwardRef as ReactComponent };